import wx from 'weixin-js-sdk'
import { Toast, Indicator } from 'mint-ui'
import constants from './constants'
import qs from 'qs'
import moment from 'moment'

let commons = {}

const kilobit = numStr => {
  if (numStr || numStr == '0') {
    return Number(numStr).toLocaleString()
  }
}

//数字保留整数
const parseIntNum = num => {
  if (num || num == '0') {
    return parseInt(num)
  }
}

/* 验证码倒计时实现变量 */
commons.VCodeObj = {
  timeCount: 60,
  timer: null
}

// 提示弹窗
commons.tipToast = function (msg) {
  Toast({
    message: msg,
    className: 'longMsgStyle',
    duration: '1500'
  })
}


// 去所有空格
commons.trimAll = function (str) {
  let result;
  if (str == null || typeof (str) == 'undefined') {
    return null;
  }
  result = str.replace(/(^\s+)|(\s+$)/g, "");
  result = result.replace(/\s/g, "");
  if (result == null || result == '') {
    return null;
  }
  return result;
}

// 判空
commons.isEmpty = function (str) {
  if (typeof (str) == 'undefined' || str == null || str == '' || str.length == 0) {
    return true;
  }
  return false;
}

// 验证手机号码
commons.checkMobile = function (mobile) {
  return /^(1[3,4,5,6,7,8,9][0-9])\d{8}$/.test(mobile)
}

// 获取链接中的属性值
commons.getUrlKey = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// vue 模拟a标签锚点跳转
commons.tapToTop = function (id) {
  document.getElementById(id).scrollIntoView(true);
}

/*
* 页面回滚,恢复正常
*（IOS页面输入法弹出顶起，完成输入后页面没有回落）
* */
commons.blurPageScroll = function () {
  setTimeout(function () {
    // 当input 失焦时,滚动一下页面就可以使页面恢复正常
    const timer = setInterval(() => {
      let currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      const speed = 1;//页面滚动距离
      currentPosition -= speed;
      window.scrollTo(0, currentPosition)
      clearInterval(timer);
    }, 1)
  }, 200)
}

/* 跳转页面 */
commons.redirect = function (vm, path, params) {
  const router = vm.$router;
  router.push({
    path: '/' + path,
    params: params
  })
}

// 判断sessionStorage值是否为空

// 微信分享
commons.wxShare = function (vm, shareInfo) {
  vm.$axios.get(constants.WXSHAREURL, {})
    .then(function (res) {
      wx.config({
        debug: false,
        appId: res.data.data.appId,
        timestamp: res.data.data.timestamp,
        nonceStr: res.data.data.nonceStr,
        signature: res.data.data.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      });
    }).catch(function (error) {
      return
    })
  wx.ready(function () {
    //分享到朋友圈
    wx.onMenuShareTimeline({
      title: shareInfo.title, // 分享标题
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    //分享给朋友
    wx.onMenuShareAppMessage({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    //分享到QQ
    wx.onMenuShareQQ({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    //分享到腾讯微博
    wx.onMenuShareWeibo({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    //分享到QQ空间
    wx.onMenuShareQZone({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
  });
}

commons.getVCodeAdminNew = function (vm, button_event) {
  const that = this
  if (that.isEmpty(vm.mobile)) {
    that.tipToast('请输入手机号码')
    return
  }
  if (that.trimAll(vm.mobile).length != 11) {
    that.tipToast('手机号码格式不正确')
    return
  }
  let event = button_event.currentTarget
  event.disabled = true
  vm.$axios.get(constants.GETVCODE_ADMINURL + vm.mobile + '?loginType=ICM').then(function (res) {
    if (!res.data.data) {
      event.disabled = false;
      that.tipToast(res.data.msg)
      return
    }
    vm.vCodeStr = that.VCodeObj.timeCount + 's'
    that.VCodeObj.timer = setInterval(() => {
      that.VCodeObj.timeCount--
      if (that.VCodeObj.timeCount > 0) {
        vm.vCodeStr = that.VCodeObj.timeCount + 's'
      } else {
        clearInterval(that.VCodeObj.timer); // 清除js定时器
        event.disabled = false;
        vm.vCodeStr = '重新获取';
        that.VCodeObj.timeCount = 60; // 重置时间
      }
    }, 1000);
    that.tipToast(res.data.msg)
    return
  }).catch(function (error) {
    event.disabled = false;
    that.tipToast(error.data.msg)
    return
  });
}

/**
 *
 * @param {*} vm
 * @param {*} button_event
 * @param {*} params ?validTime=1，? 为必须
 * @returns
 */
commons.getVCodeAdmin = function (vm, button_event, params = "") {
  const that = this
  if (that.isEmpty(vm.mobile)) {
    that.tipToast('请输入手机号码')
    return
  }
  if (that.trimAll(vm.mobile).length != 11) {
    that.tipToast('手机号码格式不正确')
    return
  }
  let event = button_event.currentTarget
  event.disabled = true
  vm.$axios.get(constants.GETVCODE_ADMINURL + vm.mobile + params).then(function (res) {
    if (!res.data.data) {
      event.disabled = false;
      that.tipToast(res.data.msg)
      return
    }
    vm.vCodeStr = that.VCodeObj.timeCount + 's'
    that.VCodeObj.timer = setInterval(() => {
      that.VCodeObj.timeCount--
      if (that.VCodeObj.timeCount > 0) {
        vm.vCodeStr = that.VCodeObj.timeCount + 's'
      } else {
        clearInterval(that.VCodeObj.timer); // 清除js定时器
        event.disabled = false;
        vm.vCodeStr = '重新获取';
        that.VCodeObj.timeCount = 60; // 重置时间
      }
    }, 1000);
    that.tipToast(res.data.msg)
    return
  }).catch(function (error) {
    event.disabled = false;
    that.tipToast(error.data.msg)
    return
  });
}

commons.getVCodeMarketing = function (vm, button_event) {
  const that = this
  if (that.isEmpty(vm.mobile)) {
    that.tipToast('请输入手机号码')
    return
  }
  if (that.trimAll(vm.mobile).length != 11) {
    that.tipToast('手机号码格式不正确')
    return
  }
  let event = button_event.currentTarget
  let data = { "mobile": vm.mobile }
  event.disabled = true
  vm.$axios.post(constants.GETVCODE_MKTURL, qs.stringify(data)).then(function (res) {
    vm.vCodeStr = that.VCodeObj.timeCount + 's'
    that.VCodeObj.timer = setInterval(() => {
      that.VCodeObj.timeCount--
      if (that.VCodeObj.timeCount > 0) {
        vm.vCodeStr = that.VCodeObj.timeCount + 's'
      } else {
        clearInterval(that.VCodeObj.timer); // 清除js定时器
        event.disabled = false;
        vm.vCodeStr = '重新获取';
        that.VCodeObj.timeCount = 60; // 重置时间
      }
    }, 1000);
    that.tipToast(res.data.msg)
    return
  }).catch(function (error) {
    event.disabled = false;
    that.tipToast(error.data.msg)
    return
  });
}

commons.getVCodeMarketingCode = function (vm, button_event) {
  const that = this
  if (that.isEmpty(vm.mobile)) {
    that.tipToast('请输入手机号码')
    return
  }
  if (that.trimAll(vm.mobile).length != 11) {
    that.tipToast('手机号码格式不正确')
    return
  }
  let event = button_event.currentTarget
  let data = { "mobile": vm.mobile }
  event.disabled = true
  vm.$axios.post(constants.GETVCODE_MKTURL_CODE, qs.stringify(data)).then(function (res) {
    vm.vCodeStr = that.VCodeObj.timeCount + 's'
    that.VCodeObj.timer = setInterval(() => {
      that.VCodeObj.timeCount--
      if (that.VCodeObj.timeCount > 0) {
        vm.vCodeStr = that.VCodeObj.timeCount + 's'
      } else {
        clearInterval(that.VCodeObj.timer); // 清除js定时器
        event.disabled = false;
        vm.vCodeStr = '重新获取';
        that.VCodeObj.timeCount = 60; // 重置时间
      }
    }, 1000);
    that.tipToast(res.data.msg)
    return
  }).catch(function (error) {
    event.disabled = false;
    that.tipToast(error.data.msg)
    return
  });

}


commons.getFirstName = function (fullName) {
  let hyphenated = [
    '欧阳', '太史', '端木', '上官', '司马', '东方', '独孤', '南宫', '万俟', '闻人',
    '夏侯', '诸葛', '尉迟', '公羊', '赫连', '澹台', '皇甫', '宗政', '濮阳', '公冶',
    '太叔', '申屠', '公孙', '慕容', '仲孙', '钟离', '长孙', '宇文', '城池', '司徒',
    '鲜于', '司空', '汝嫣', '闾丘', '子车', '亓官', '司寇', '巫马', '公西', '颛孙',
    '壤驷', '公良', '漆雕', '乐正', '宰父', '谷梁', '拓跋', '夹谷', '轩辕', '令狐',
    '段干', '百里', '呼延', '东郭', '南门', '羊舌', '微生', '公户', '公玉', '公仪',
    '梁丘', '公仲', '公上', '公门', '公山', '公坚', '左丘', '公伯', '西门', '公祖',
    '第五', '公乘', '贯丘', '公皙', '南荣', '东里', '东宫', '仲长', '子书', '子桑',
    '即墨', '达奚', '褚师'];
  let hySet = new Set(hyphenated);
  let vLength = fullName.length;
  let lastName = '', firstName = '';
  if (vLength > 2) {
    let preTwoWords = fullName.substr(0, 2);
    // 取命名的前两个字,看是否在复姓库中
    if (hySet.has(preTwoWords)) {
      firstName = preTwoWords;
      // firstName = fullName.substr(2);
    } else {
      firstName = fullName.substr(0, 1);
      // firstName = fullName.substr(1);
    }
  } else if (vLength === 2) {
    // 全名只有两个字时,以前一个为姓,后一下为名
    firstName = fullName.substr(0, 1);
    // firstName = fullName.substr(1);
  } else {
    firstName = fullName;
  }
  return firstName;
},



  commons.throttle = function (fn, vm, gapTime) {
    if (gapTime == null || gapTime == undefined) {
      gapTime = 1500
    }
    let _lastTime = null
    // return fn.apply(this, arguments)   //将this和参数传给原函数
    // 返回新的函数
    return function () {
      let _nowTime = + new Date()
      if (_nowTime - _lastTime > gapTime || !_lastTime) {
        var context = vm
        fn.apply(context, arguments)   //将this和参数传给原函数
        _lastTime = _nowTime
      }
    }
  }

commons.isWeChat = function () {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
    return true
  } else {
    return false
  }
}

commons.verifyMobile = (mobile) => {
  const reg = /^1[3456789]\d{9}$/;
  if (reg.test(mobile)) {
    return true
  }
  return false
}

commons.checkAcctId =  (acctId)=> {
  if (!acctId || !/^(?:\d{16}|\d{19})$/g.test(acctId)) {
    return false;
  }
  return true
};


// 获取时间差
commons.timeDiff = (recordTime) => {
  return moment().unix() - moment(recordTime).unix()
}
// 身份证
commons.checkIdCard = function (value) {
  let isValid = true
  const cityCode = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }

  /* 15位校验规则： (dddddd yymmdd xx g)    g奇数为男，偶数为女
   * 18位校验规则： (dddddd yyyymmdd xxx p) xxx奇数为男，偶数为女，p校验位
   校验位公式：C17 = C[ MOD( ∑(Ci*Wi), 11) ]
   i----表示号码字符从由至左包括校验码在内的位置序号
   Wi 7 9 10 5 8 4 2 1 6 3 7 9 10 5 8 4 2 1
   Ci 1 0 X 9 8 7 6 5 4 3 2
   */
  const rFormat = /^\d{6}(18|19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$|^\d{6}\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/

  if (!rFormat.test(value) || !cityCode[value.substr(0, 2)]) {
    isValid = false
  } else if (value.length === 18) { // 18位身份证需要验证最后一位校验位
    // 加权因子
    const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]
    // 校验字符
    const Ci = '10X98765432'
    // 加权求和
    let sum = 0
    for (let i = 0; i < 17; i++) {
      sum += value.charAt(i) * Wi[i]
    }
    // 计算校验值
    let C17 = Ci.charAt(sum % 11)
    // 与校验位比对
    if (C17 !== value.charAt(17)) {
      isValid = false
    }
  }
  return isValid
}


  // 获取时间差
  commons.timeDiff = (recordTime) => {
    return moment().unix() - moment(recordTime).unix()
  }

  commons.getVCodeNew = function (that, params = '') {
    const { mobile } = that
    if (this.isEmpty(mobile)) {
      this.tipToast('请输入手机号码')
      return
    }
    if (!this.checkMobile(mobile)) {
      this.tipToast('手机号码格式不正确')
      return
    }
    Indicator.open({
      text: '加载中...',
      spinnerType: 'fading-circle'
    });
    that.vCodeBtnDisabled = true
    try {
      that.$axios.get(`${constants.GETVCODE_ADMINURL}${mobile}${params}`).then(({data:{code, success, msg}})=>{
        Indicator.close()
        if(code === 0) {
          this.tipToast(msg)
          sessionStorage.setItem('smsSendTime', JSON.stringify(new Date()))
          let timer = setInterval(()=>{
            const smsSendTime = JSON.parse(sessionStorage.getItem('smsSendTime'))
            let countdownNum = 60 - this.timeDiff(smsSendTime)
            if(countdownNum > 0) {
              that.vCodeBtnStr = countdownNum + 's'
            }else{
              clearInterval(timer)
              that.vCodeBtnStr = '重新获取'
              that.vCodeBtnDisabled = false
              sessionStorage.removeItem('smsSendTime')
            }
          }, 1000)
        } else {
          that.vCodeBtnDisabled = false
          this.tipToast('验证码获取失败，请重新获取')
        }
      }).catch(err=>{
        Indicator.close()
        that.vCodeBtnDisabled = false
        this.tipToast(err.data.msg || '系统错误')
      })
    } catch(err) {
      Indicator.close()
      that.vCodeBtnDisabled = false
      this.tipToast('验证码获取失败，请重新获取')
    }

  }

export default commons;



// WEBPACK FOOTER //
// ./src/utils/common.js